import { useToast } from "@/components/ui/use-toast";
import { createActorContext } from "@xstate/react";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";

type UseXStateFormProps = {
  machineContext: ReturnType<typeof createActorContext>;
  successToast?: string;
};

export const useXStateForm = ({ machineContext, successToast }: UseXStateFormProps) => {
  const { values, setSubmitting, resetForm, setFieldError, setFieldTouched, isSubmitting } =
    useFormikContext<Record<string, unknown>>();
  const value = machineContext.useSelector((state) => state.value);
  const failedError = machineContext.useSelector((state) => state.context.failedError);
  const { toast } = useToast();
  const [isRequesting, setIsRequesting] = useState(false);

  useEffect(() => {
    if (!isSubmitting || value.indexOf("submitting") === -1) {
      return;
    }

    setIsRequesting(true);
  }, [value, isSubmitting]);

  useEffect(() => {
    if (!isSubmitting || !isRequesting) {
      return;
    }

    if (failedError) {
      setSubmitting(false);
      resetForm();

      toast({ title: failedError, variant: "error" });
    } else if (value.indexOf("submitting") === -1) {
      setSubmitting(false);
      setIsRequesting(false);

      for (const [key] of Object.entries(values)) {
        setFieldTouched(key, false);
      }

      if (successToast) {
        toast({ title: successToast, variant: "success" });
      }
    }

    setFieldError("submit", failedError);
  }, [
    value,
    values,
    failedError,
    resetForm,
    setSubmitting,
    setFieldError,
    setFieldTouched,
    isSubmitting,
    isRequesting,
    toast,
    successToast
  ]);
};
